import { ReactNode } from "react";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { searchFilterStore } from "entities/SearchFilter";
import { useAppSelector } from "shared/lib/redux";
import { ValueOf } from "shared/lib/typeCheck.lib";
import { AirFilteredCardsView } from "./FilteredCardsViews/AirFilteredCardsView";
import { SeaFilteredCardsView } from "./FilteredCardsViews/SeaFilteredCardsView";

type FilteredCardsLayerProps = {
  className?: string;
};

const filteredCardsViewsMap: Record<ValueOf<typeof ShipmentType>, (props: FilteredCardsLayerProps) => ReactNode> = {
  [ShipmentType.AIR]: (props) => <AirFilteredCardsView {...props} />,
  [ShipmentType.SEA]: (props) => <SeaFilteredCardsView {...props} />,
  [ShipmentType.RAIL]: (props) => <div {...props} />,
  [ShipmentType.ROAD]: (props) => <div {...props} />,
  [ShipmentType.PARCEL]: (props) => <div {...props} />,
};

export const FilteredCardsView: RFC<FilteredCardsLayerProps> = ({ className }) => {
  const shipmentType = useAppSelector(searchFilterStore.selectors.shipment);

  return filteredCardsViewsMap[shipmentType]?.({ className });
};
